import ReactModal from "react-modal";
import {useState} from "react";
import {CdaWebModalErrorBox} from './cdawebmodal/cdawebmodalerrorbox.js';
import {CDAERRORCODES} from './../constants.js';
import {ReportProblemForm} from './reportproblemform.js';


/**
 * A modal component for reporting problems.
 *
 * @param {Object} props - The props object containing title, isReportProblemModalOpen, and setReportProblemModalOpen.
 * @param {string} props.title - The title of the modal.
 * @param {boolean} props.isReportProblemModalOpen - Indicates whether the report problem modal is open.
 * @param {function} props.setReportProblemModalOpen - Function to toggle the report problem modal's visibility.
 * @returns {JSX.Element} - JSX element representing the report problem modal.
 */
export function ReportProblemModal(props) {
    const {isReportProblemModalOpen, setReportProblemModalOpen} = props;
    const [modalError, setModalError] = useState(null);
    const [submitted, setSubmitted] = useState(false);

    const onRequestClose = () => {
        setSubmitted(false);
        setReportProblemModalOpen(false);
    };


    return (
        <ReactModal
          overlayClassName="reportProblemModalOverlay"
          className="reportProblemModalContent"
          contentLabel="Report Problem Modal"
          isOpen={isReportProblemModalOpen}
          onRequestClose={onRequestClose}>
          <div className="reportProblemModalContainer">
            {!submitted && <div className="reportProblemModalCloseButtonContainer">
              <button onClick={onRequestClose} className="reportProblemModalCloseButton">Close</button>
            </div>}
            {modalError &&
                 <CdaWebModalErrorBox title= {CDAERRORCODES['004']} body={modalError.message}/>
             }
            <ReportProblemForm setModalError = {setModalError}
                               submitted = {submitted}
                               setSubmitted = {setSubmitted} />
            {submitted && <div className="reportProblemModalCloseButtonContainer big">
              <button onClick={onRequestClose} className="reportProblemModalCloseButton big">Close</button>
            </div>}
          </div>
        </ReactModal>
    );
}
